import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Card,
  Container,
  Modal,
  Form,
  Row,
  Col,
  InputGroup,
  FormControl,
  Spinner,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Layout from "../../layout/Layout";

// API Fonksiyonlarını Import Ediyoruz
import {
  getCustomers,
  insertCustomer,
  updateCustomer, // GÜNCELLEME API FONKSİYONU EKLENDİ (API dosyasında tanımlamalısın)
  deleteCustomer,
} from "../../../api/disticaret/customerApi";

const CURRENT_USER_PERMISSIONS = [
  "customer_get",
  "customer_post", // Ekleme ve Güncelleme için kullanılıyor
  "customer_delete",
];

const Icons = {
  Plus: () => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="12" y1="5" x2="12" y2="19"></line>
      <line x1="5" y1="12" x2="19" y2="12"></line>
    </svg>
  ),
  Eye: () => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
      <circle cx="12" cy="12" r="3"></circle>
    </svg>
  ),
  Edit: () => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
    </svg>
  ),
  Trash: () => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="3 6 5 6 21 6"></polyline>
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
    </svg>
  ),
  Search: () => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#6c757d"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
  ),
  MapPin: () => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#6c757d"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
      <circle cx="12" cy="10" r="3"></circle>
    </svg>
  ),
};

const CompanyAvatar = ({ name }) => {
  const initials = name ? name.substring(0, 2).toUpperCase() : "NA";
  return (
    <div
      className="d-flex align-items-center justify-content-center fw-bold text-primary bg-primary bg-opacity-10 rounded-circle me-3"
      style={{
        width: "42px",
        height: "42px",
        fontSize: "0.9rem",
        flexShrink: 0,
      }}
    >
      {initials}
    </div>
  );
};

export default function CustomerListPage() {
  const navigate = useNavigate();

  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [isEditing, setIsEditing] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const [formData, setFormData] = useState({
    companyName: "",
    region: "",
    sector: "",
    locationDetail: "",
    technicalCategory: "",
  });

  const hasPermission = (perm) => CURRENT_USER_PERMISSIONS.includes(perm);

  // --- API: LISTELEME ---
const fetchCustomers = async () => {
    if (!hasPermission("customer_get")) return;

    setLoading(true);
    try {
      const response = await getCustomers();
      if (response.data.success) {
        setCustomers(response.data.data);
      }
    } catch (error) {
      console.error("Veri çekilemedi", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  // EKLEME MODALINI AÇ
  const handleOpenAdd = () => {
    setIsEditing(false);
    setSelectedCustomer(null);
    setFormData({
      companyName: "",
      region: "",
      sector: "",
      locationDetail: "",
      technicalCategory: "",
    });
    setShowModal(true);
  };

  // DÜZENLEME MODALINI AÇ
  const handleOpenEdit = (customer) => {
    setIsEditing(true);
    setSelectedCustomer(customer);

    // Gelen _id formatını parse ediyoruz
    const customerId =
      typeof customer._id === "string" ? customer._id : customer._id?.$oid;

    setFormData({
      id: customerId, // Update işlemi için id gerekiyor
      companyName: customer.companyName || "",
      region: customer.region || "",
      sector: customer.sector || "",
      locationDetail: customer.locationDetail || "",
      technicalCategory: customer.technicalCategory || "",
    });
    setShowModal(true);
  };

  const handleGoToDetail = (id) => {
    const parsedId = typeof id === "string" ? id : id?.$oid;
    navigate(`/CustomerDetail/${parsedId}`);
  };

  // --- API: EKLEME & GÜNCELLEME ---
  const handleSave = async () => {
    try {
      let response;
      if (isEditing) {
        // Güncelleme İşlemi
        response = await updateCustomer(formData);
      } else {
        // Ekleme İşlemi (id alanı boş ise backend tarafında sorun yaratmaması için id'yi silebilirsiniz)
        const payload = { ...formData };
        delete payload.id;
        response = await insertCustomer(payload);
      }

      // Backend statusCode 200 veya success: true dönüyorsa listeyi yenile
      if (response.data?.success || response.data?.statusCode === 200) {
        setShowModal(false);
        fetchCustomers();
      } else {
        alert("İşlem sırasında bir hata oluştu.");
      }
    } catch (error) {
      console.error("Kaydetme hatası", error);
    }
  };

  // --- API: SİLME (Soft Delete) ---
  const handleDeleteConfirm = async () => {
    if (!selectedCustomer) return;

    try {
      const customerId =
        typeof selectedCustomer._id === "string"
          ? selectedCustomer._id
          : selectedCustomer._id?.$oid;

      const response = await deleteCustomer(customerId);

      if (response.data?.success || response.data?.statusCode === 200) {
        setShowDeleteModal(false);
        fetchCustomers(); // Sildikten sonra listeyi API'den tekrar çek
      } else {
        alert("Silme işlemi başarısız.");
      }
    } catch (error) {
      console.error("Silme hatası", error);
    }
  };

  const filteredCustomers = customers.filter(
    (c) =>
      c.companyName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      c.sector?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Layout>
      <Container
        fluid
        className="py-5 px-lg-5"
        style={{ backgroundColor: "#F3F4F6", minHeight: "100vh" }}
      >
        <Row className="align-items-center mb-4">
          <Col md={6}>
            <h3
              className="fw-bold text-dark mb-1"
              style={{ letterSpacing: "-0.5px" }}
            >
              Müşteri Yönetimi
            </h3>
            <p className="text-muted small mb-0">
              Dış ticaret müşteri portföyü ve teknik detaylar.
            </p>
          </Col>
          <Col
            md={6}
            className="d-flex justify-content-md-end gap-3 mt-3 mt-md-0"
          >
            <InputGroup className="shadow-sm" style={{ maxWidth: "260px" }}>
              <InputGroup.Text className="bg-white border-end-0">
                <Icons.Search />
              </InputGroup.Text>
              <FormControl
                placeholder="Şirket veya Sektör Ara..."
                className="border-start-0 ps-0 text-muted"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </InputGroup>

            {hasPermission("customer_post") && (
              <Button
                variant="primary"
                className="d-flex align-items-center gap-2 px-4 shadow-sm"
                onClick={handleOpenAdd}
                style={{ borderRadius: "8px" }}
              >
                <Icons.Plus /> <span>Yeni Müşteri</span>
              </Button>
            )}
          </Col>
        </Row>

        <Card
          className="border-0 shadow-sm"
          style={{ borderRadius: "16px", overflow: "hidden" }}
        >
          <Table hover responsive className="mb-0 align-middle">
            <thead className="bg-light">
              <tr>
                <th
                  className="ps-4 py-3 text-secondary small fw-bold text-uppercase border-bottom-0"
                  style={{ width: "30%" }}
                >
                  Müşteri Adı
                </th>
                <th className="py-3 text-secondary small fw-bold text-uppercase border-bottom-0">
                  Lokasyon
                </th>
                <th className="py-3 text-secondary small fw-bold text-uppercase border-bottom-0">
                  Sektör
                </th>
                <th className="py-3 text-secondary small fw-bold text-uppercase border-bottom-0">
                  Teknik Kategori
                </th>
                <th className="text-end pe-4 py-3 text-secondary small fw-bold text-uppercase border-bottom-0">
                  İşlemler
                </th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="5" className="text-center py-5">
                    <Spinner animation="border" variant="primary" />
                  </td>
                </tr>
              ) : filteredCustomers.length > 0 ? (
                filteredCustomers.map((cust) => {
                  const custId =
                    typeof cust._id === "string" ? cust._id : cust._id?.$oid;
                  return (
                    <tr key={custId} style={{ transition: "all 0.2s" }}>
                      <td className="ps-4 py-3">
                        <div className="d-flex align-items-center">
                          <CompanyAvatar name={cust.companyName} />
                          <div>
                            <div className="fw-bold text-dark">
                              {cust.companyName}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="py-3">
                        <div className="d-flex align-items-center text-secondary gap-2">
                          <Icons.MapPin />
                          <span className="fw-medium text-dark small">
                            {cust.locationDetail}{" "}
                            <span className="text-muted">({cust.region})</span>
                          </span>
                        </div>
                      </td>
                      <td className="py-3">
                        <span className="badge bg-light text-dark border px-3 py-2 rounded-pill fw-normal">
                          {cust.sector}
                        </span>
                      </td>
                      <td className="py-3 text-muted small">
                        {cust.technicalCategory}
                      </td>
                      <td className="text-end pe-4 py-3">
                        <Button
                          variant="light"
                          size="sm"
                          className="me-2 text-primary bg-primary bg-opacity-10 border-0"
                          onClick={() => handleGoToDetail(custId)}
                        >
                          <Icons.Eye /> Detay
                        </Button>

                        {/* GÜNCELLEME BUTONU */}
                        {hasPermission("customer_post") && (
                          <Button
                            variant="light"
                            size="sm"
                            className="me-2 text-secondary bg-secondary bg-opacity-10 border-0"
                            onClick={() => handleOpenEdit(cust)}
                          >
                            <Icons.Edit />
                          </Button>
                        )}

                        {/* SİLME BUTONU */}
                        {hasPermission("customer_delete") && (
                          <Button
                            variant="light"
                            size="sm"
                            className="text-danger bg-danger bg-opacity-10 border-0"
                            onClick={() => {
                              setSelectedCustomer(cust);
                              setShowDeleteModal(true);
                            }}
                          >
                            <Icons.Trash />
                          </Button>
                        )}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="5" className="text-center py-5 text-muted">
                    Kayıt bulunamadı.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Card>
      </Container>

      {/* --- EKLEME / GÜNCELLEME MODALI --- */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        className="fade-scale"
        size="lg"
      >
        <Modal.Header closeButton className="border-0 pb-0 ps-4 pt-4">
          <Modal.Title className="fw-bold fs-5">
            {isEditing ? "Müşteriyi Güncelle" : "Yeni Müşteri Ekle"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Form>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold text-secondary">
                    Şirket Adı
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="companyName"
                    value={formData.companyName}
                    onChange={handleInputChange}
                    placeholder="Örn: ZDN UK Ltd."
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold text-secondary">
                    Sektör
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="sector"
                    value={formData.sector}
                    onChange={handleInputChange}
                    placeholder="Örn: Otomotiv"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold text-secondary">
                    Bölge (Kısa Kod)
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="region"
                    value={formData.region}
                    onChange={handleInputChange}
                    placeholder="Örn: UK"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold text-secondary">
                    Lokasyon Detayı
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="locationDetail"
                    value={formData.locationDetail}
                    onChange={handleInputChange}
                    placeholder="Örn: Londra, İngiltere"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-3">
              <Form.Label className="small fw-semibold text-secondary">
                Teknik Kategori
              </Form.Label>
              <Form.Control
                type="text"
                name="technicalCategory"
                value={formData.technicalCategory}
                onChange={handleInputChange}
                placeholder="Örn: Otomotiv Yan Sanayi"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="border-0 px-4 pb-4">
          <Button variant="light" onClick={() => setShowModal(false)}>
            Vazgeç
          </Button>
          <Button variant="primary" onClick={handleSave}>
            {isEditing ? "Değişiklikleri Kaydet" : "Kaydet"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* --- SİLME MODALI --- */}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
        size="sm"
      >
        <Modal.Body className="text-center p-4">
          <div
            className="bg-danger bg-opacity-10 text-danger rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
            style={{ width: "50px", height: "50px" }}
          >
            <Icons.Trash />
          </div>
          <h5 className="fw-bold mb-2">Emin misiniz?</h5>
          <p className="text-muted small mb-4">
            <strong>{selectedCustomer?.companyName}</strong> adlı müşteri kalıcı
            olarak silinecektir.
          </p>
          <div className="d-grid gap-2">
            <Button variant="danger" onClick={handleDeleteConfirm}>
              Evet, Sil
            </Button>
            <Button variant="light" onClick={() => setShowDeleteModal(false)}>
              İptal
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </Layout>
  );
}
